module.exports = __webpack_public_path__ + "static/img/grandpa_g.4b0d9a34.png";